import { render, staticRenderFns } from "./InputNewAddress.vue?vue&type=template&id=677c3705"
import script from "./InputNewAddress.vue?vue&type=script&lang=js"
export * from "./InputNewAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports